import 'semantic-ui-css/semantic.min.css'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import './App.css';
import Layout from "./pages/Layout";
import { Helmet } from 'react-helmet-async'
import Inquiry from "./pages/Inquiry";

const App = () => {

  return (
      <BrowserRouter>
      <Helmet>
        <head>MG & J's General</head>
        <meta name="description" content="Welcome to MG & J's General's Website!"/>
        <link rel="canonical" href="/" />
      </Helmet>
      <Routes>
        <Route path="/">
          <Route index element={<Inquiry />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;